const round = (num: number, decimalPlaces = 0): number => {
  if (num < 0) return -round(-num, decimalPlaces)

  var p = Math.pow(10, decimalPlaces)
  var n = parseFloat((num * p).toPrecision(15))
  return Math.round(n) / p
}

export default round
